// @mui
import { styled } from '@mui/material/styles';
import { Divider } from '@mui/material';
// components
import Page from '../components/Page';
import { AboutHero, AboutWhat, AboutTeam, AboutVision, AboutTestimonials } from '../sections/about';
import Typeoflogin from 'src/newsection/auth/logintype/Typeoflogin';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(7),
    [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(7),
        paddingBottom: theme.spacing(0),
    },
}));

// ----------------------------------------------------------------------

export default function LoginTypepage() {
    return (
        <Page title="Login">
            <RootStyle sx={{bgcolor: '#0E2135',  }}>

                <Typeoflogin  />

            </RootStyle>
        </Page>
    );
}
